import type { InvoiceOverview } from '@vy/api-definition';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useConnectedIntegrations } from '../../../hooks/requests/use-integrations';
import { useUsageEventsReportConfiguration } from '../../../hooks/requests/use-usage-events-report-configuration';
import { invalidateInvoicesQueries } from '../../../utils/query-invalidation';

export const useInvoicesData = () => {
  const [selectedInvoices, setSelectedInvoices] = useState<InvoiceOverview[]>([]);
  const queryClient = useQueryClient();

  const { data: connectedIntegrations = [] } = useConnectedIntegrations();
  const { data: reportConfig } = useUsageEventsReportConfiguration();
  const hasUsageEventsReportConfiguration = reportConfig?.configured ?? false;

  const resetInvoicesQuery = async () => {
    await invalidateInvoicesQueries(queryClient);
  };

  return {
    selectedInvoices,
    setSelectedInvoices,
    connectedIntegrations,
    resetInvoicesQuery,
    hasUsageEventsReportConfiguration,
  };
};
